<div id="printClientLoyaltyPointsInfo">
  <div class="modal-header">
    <h5 class="modal-title text-capitalize" id="exampleModalLabel">
      <i class="fas fa-plus"></i> {{'NewDownPayment' | translate}}
    </h5>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <app-add-client-down-payment [SendBookingId]="BookingId" [PaymentMainPage]="PaymentMainPage"
      (LoadData)="DoneAddMethod()"></app-add-client-down-payment>

  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-danger" (click)="activeModal.close('Close click')">
      {{'Close' | translate}}</button>
  </div>
</div>
